export default __webpack_public_path__ + "static/media/zayed-project-2.0247dd9c.webp";